
import {ø} from "./util/objects.js";
import {$} from "./util/seq.js";
import {computeViewbox} from "./ux/viewbox.js";
import {createAgent} from "./framework/agent.js";
import {report} from "./report.js";


function newAgent(name, options) {
    return createAgent(ø(options, {name})).on($`reject fail`, report.error);
}

export function createEngineAgents() {
    return {
        viewboxAgent: newAgent(                         // the dimensions of the display
            "viewbox",
            {initial: computeViewbox()}
        ),
        mapAgent: newAgent("map"),                      // map data for the earth
        globeAgent: newAgent("globe"),                  // the model of the globe
        layerManagerAgent: newAgent("layer"),           // the layers of weather data
        primaryLayerAgent: newAgent("primaryLayer"),
        overlayLayerAgent: newAgent("overlayLayer"),
        activeLayerAgent: newAgent("activeLayer"),
        annotationLayerAgent: newAgent("annotLayer"),
        rendererAgent: newAgent(                        // the globe SVG renderer
            "renderer",
            {events: ["start", "render", "redraw"]}
        ),
        fieldAgent: newAgent("field"),                  // interpolated wind vector field
        fastoverlayAgent: newAgent("fastoverlay"),      // webgl overlay renderer
        animatorAgent: newAgent("animator"),            // the wind animator
        overlayAgent: newAgent("overlay"),              // overlay renderer
        overlayGridAgent: newAgent("overlayGrid"),      // grid point renderer
    };
}
